import React from 'react';
import BackVideo from '../../components/BackVideo';
import SideLines from '../../components/Svg/side-lines';
import TopLines from '../../components/Svg/top-lines';
// import Bg from '../../assets/img/bg-map-main.png';
import Languages from '../../const/languages';
import ProjectDecor from '../../components/Svg/project-decor';
import ProductDecor from '../../components/Svg/product-decor';
import { products as productsOriginal } from '../../const/projects';
import noContentImage from '../../assets/img/catalog/nocontent.png';
import Carousel from '@brainhubeu/react-carousel';
import '../../components/Swipe/slider.css';
import Cart from '../../components/Cart/cart';
import Popup from '../../components/Popup';
import {CSSTransition, TransitionGroup} from 'react-transition-group';

const products = JSON.parse(JSON.stringify(productsOriginal));

export default (props) => {
    const {
        children,
        video,
        driverVideo,
        title,
        popup,
        bg: Bg,
        popupOpenHandler,
        popupCloseHandler,
        driver,
        onEnded,
        currentProject,
    } = props;

    const { classSfx: popupType, opened: popupOpened, data: popupData } = popup;

    const popupContent = (() => {
        if (popup && popupOpened && popupType === 'project') {
            // const itemBg = require('../../assets/img/project/'+popupData.id+'.jpg');

            let styles = null;

            try {
                styles = { backgroundImage: `url(${require('../../assets/img/project/' + popupData.id + '.jpg')})` };
            } catch (e) {
                styles = { backgroundColor: '#4fb0f2' };
            }

            return (
                <>
                    <div className = 'item-main'>
                        <div className = 'popup__title h1'>{Languages.projectsTitle}</div>

                        <div className = 'item-name h3 font-weight-normal'>{popupData.name}</div>

                        <div className = 'triple-line'/>

                        <div className = 'item-title h4'>{popupData.description.title}</div>

                        <div className = 'item-location h6 font-weight-normal font-italic'>{Languages.location}: {popupData.description.location}</div>

                        <div
                            className = 'item-photo'
                            style = { styles }>
                            <ProjectDecor/>
                            <ProjectDecor/>
                        </div>

                        <div className = 'single-line'/>
                    </div>

                    { popupData.products.length ? (
                        <div className = 'item-products'>
                            <div className = 'swipe font-weight-medium h4'>
                                <Carousel
                                    arrows
                                    slidesPerPage = { 2 }
                                    slidesPerScroll = { 2 }
                                >
                                    {popupData.products.map((item, index) => {
                                        if (typeof item === 'number') {
                                            const product = products.find((key) => key.id === item);
                                            const img = require('../../assets/img/catalog/' + product.photo + '.png');

                                            return (
                                                <div
                                                    className = { 'li li-number' }
                                                    key = { index }>
                                                    <div
                                                        className = 'product-item'
                                                        onClick = { () => popupOpenHandler(product, 'cart') }
                                                    >
                                                        <ProductDecor className = 'product-decor' />

                                                        <div
                                                            className = 'product-photo'
                                                            style = {{backgroundImage: `url(${img})`}}/>

                                                        <div className = 'product-info'>
                                                            <span className = 'product-name'>{product.name}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }

                                        return (
                                            <div
                                                className = { 'li li-string' }
                                                key = { index }>
                                                <div
                                                    className = 'product-item'
                                                    onClick = { (e) => { e.preventDefault(); e.stopPropagation(); } }>
                                                    <ProductDecor className = 'product-decor' />

                                                    <div
                                                        className = 'product-photo'
                                                        style = {{backgroundImage: `url(${noContentImage})`}}/>

                                                    <div className = 'product-info'>
                                                        <span className = 'product-name'>{item}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </Carousel>
                            </div>
                        </div>
                    ) : null }
                </>
            );
        }

        if (popup && popupOpened && popupType === 'cart') {
            return (
                <Cart
                    cart = { popupData }
                    closeHandler = { () => popupOpenHandler(currentProject, 'project') }
                />
            );
        }
    })();

    return (
        <>
            <section className = { `page-section${popupOpened ? ' in-blur' : ''}` }>
                <div className = 'hud hud-map'>
                    <div className = 'hud__container-decor'>
                        <div className = 'hud__bg'>
                            {video && (
                                <div
                                    className = 'hud__bg__video'
                                    style = {{backgroundImage: 'url(' + Bg + ')'}}
                                >
                                    <BackVideo
                                        video = { video }
                                    />

                                    {driver && driverVideo && (
                                        <BackVideo
                                            video = { driverVideo }
                                            onEnded = { onEnded }
                                            loop = { false }
                                        />
                                    )}
                                </div>
                            )}
                            <div className = 'hud__bg__decor-top'/>
                            <div className = 'hud__bg__decor-bottom'/>
                        </div>

                        <div
                            className = 'hud__header'
                            style = {{height: '70px'}}>
                            <div className = 'hud__header__decor__container'>
                                <div className = 'hud__header__decor__row-1 hud__header__decor__row-center'>
                                    <div className = 'hud__header__decor__item'>
                                        <TopLines />
                                    </div>
                                </div>

                                <div className = 'hud__header__decor__row-2 hud__header__decor__row-space-between'>
                                    <div className = 'hud__header__decor__item'>
                                        <SideLines />
                                    </div>

                                    <div className = 'hud__header__decor__item hud__header__decor__item-reverse'>
                                        <SideLines />
                                    </div>
                                </div>
                            </div>

                            {title && (
                                <div className = 'hud__header__title'>
                                    {title}
                                </div>
                            )}
                        </div>

                        <div
                            className = 'hud__footer'
                            style = {{height: '50px'}}
                        >
                            <div className = 'hud__footer__decor__container'>
                                <div className = 'hud__footer__decor__row-1 hud__footer__decor__row-center'>
                                    <div className = 'hud__footer__decor__item'>
                                        <TopLines />
                                    </div>
                                </div>

                                <div className = 'hud__footer__decor__row-2 hud__footer__decor__row-space-between'>
                                    <div className = 'hud__footer__decor__item'>
                                        <SideLines />
                                    </div>

                                    <div className = 'hud__footer__decor__item hud__footer__decor__item-reverse'>
                                        <SideLines />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {children}
                </div>
            </section>

            <TransitionGroup>
                { popupOpened && (
                    <CSSTransition
                        classNames = 'fade'
                        timeout = { 300 }
                    >
                        <Popup
                            opened
                            closeHandler = { popupCloseHandler }
                            contentClassSfx = { `${popupType}-item` }
                            showCloseButton = { popupType === 'project' }
                        >
                            { popupContent }
                        </Popup>
                    </CSSTransition>
                ) }
            </TransitionGroup>
        </>
    );
};
